const yup = require("yup");

const deleteValidator = yup.object({
  delete: yup.string().oneOf(["Delete"], "Delete is the expected value").required("Delete is a required field"),
});
module.exports = {
  deleteValidator,
};
